<template>
  <section>
    <br />
    <div class="columns is-mobile is-centered">
      <div class="column is-half">
        <div class="card" style="width: 400px">
          <header class="card-header">
            <p class="card-header-title">Email Bevestigen</p>
          </header>
          <div class="card-content">
            <div class="field is-horizontal">
              <div class="field-body">
                <div class="field">
                  Klik op de knop hieronder om je Email-adres te bevestigen!
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <button @click="confirmMethod()" class="button is-primary is-fullwidth">
                      Bevestig Email-adres
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="field is-horizontal" v-if="succes">
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <br />
                    <b-message title="Success" type="is-success">Succesvol Bevestigd.</b-message>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import userService from '@/services/userService.js'
import router from '@/router/index.js'

export default {
  components: {},
  data() {
    return {
      succes: false
    }
  },

  computed: {
    code() {
      return this.$route.query.code
    },
    userId() {
      return this.$route.query.userId
    }
  },
  methods: {
    async confirmMethod() {
      const res = await userService.confirmEmail(this.userId, this.code)
      if (res.status == 200) {
        this.succes = true
        setTimeout(() => {
          this.$router.push('/login')
        }, 2000)
      }
    }
  }
}
</script>

<style lang="css" scoped>
section {
  margin-top: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/Auth/AuthConfirm.vue